import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';

import { Observable, throwError } from 'rxjs';
import { ArrayResponse, BaseResponse } from '../_common';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MoQualityAssessmentService {

  constructor(private http: HttpClient) { }

  getAll(filter: any, realtimeFlag: boolean): Observable<BaseResponse>  { //listing
    return this.http.post(`${environment.apiUrl}/report/qa/graph?realtime=${realtimeFlag}`, filter)
    .pipe(
      map((data: any) => {
        return data;
      }),
      catchError(error => throwError(error.message || error))
    );
  }

  export(filter: any, realtimeFlag: boolean): Observable<any> { //export
    return this.http.post(`${environment.apiUrl}/report/qa/export?realtime=${realtimeFlag}`, filter);
  }
}
